import { render } from "./DownArrow.vue?vue&type=template&id=47d1662e"
import script from "./DownArrow.vue?vue&type=script&lang=js"
export * from "./DownArrow.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sung-a/.jenkins/workspace/Sunga/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__